import {Box} from '@mui/material';
import {DataGridPro, GridToolbar} from '@mui/x-data-grid-pro';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';



export default function LoadListExport(props){
    //console.debug("RTS Break LoadListExport");


    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));


    const columns = [
        {
            field: 'curOwner', 
            headerName: "Owner", 
            description:"Current Owner", 
        },
        {
            field: 'curCrew', 
            headerName: "Crew", 
            description:"Current Crew", 
        },        
        {
            field: 'curAliasName',
            headerName: 'Product',
            description: 'Customer Product Name',
        },
        {
            field: 'curAliasNumber',
            headerName: 'Product No.',
            description: 'Customer Product Number'
        },
        {
            field: 'curProductIdSap', 
            headerName: "SW Product No.", 
            description: "Southwire Product Number", 
        },
        {
            field: 'projectName', 
            headerName: "Project", 
            description:"Project Name", 
        }, 
        {
            field: 'amt', 
            headerName: "Length Purchased", 
            description:"The Length of Product Purchased in Feet", 
            valueGetter: (value, row) => {
                return row.amt.toLocaleString(undefined, { maximumFractionDigits: 2 });
            }
        },           
        {
            field: 'uom', 
            headerName: "Length Unit of Measure", 
            description:"The Unit of Measure for Length Purchased", 
            valueGetter: (value, row) => {
                return 'ft';
            }
        },
        {
            field: 'lengthRemaining', 
            headerName: "Remaining Length", 
            description:"The Remaining Length on the Reel", 
            valueGetter: (value, row) => {
                return Math.floor(row.amt - row.curPullSum).toLocaleString(undefined, { maximumFractionDigits: 2 });
            }
        },
        {
            field: 'age', 
            headerName: "Age of Product (Days)", 
            description:"The Age of Product on the Reel in Days", 
            valueGetter: (value, row) => {
                return row.shipDateDays.toLocaleString();
            }
        },
        {
            field: 'customerPo', 
            headerName: "Purchase Order", 
            description:"The Customer Purchase Order", 
        }, 
        {
            field: 'shippingOrder', 
            headerName: "Shipping Order", 
            description:"The Shipping Order", 
        }, 
        {
            field: 'packingListNo', 
            headerName: "Packing List No", 
            description:"Packing List No", 
        }, 
        {
            field: 'billOfLading', 
            headerName: "Bill of Lading", 
            description:"Bill of Lading", 
        }, 
        {
            field: 'batchNo', 
            headerName: "Batch Number", 
            description:"Batch Number", 
        }, 
        {
            field: 'shipDate', 
            headerName: "Ship Date", 
            description:"The Order Ship Date", 
            valueGetter: (value, row) => {
                if(value == null){
                    return null;
                }

                return (
                    new Date(value)
                );
            },
            type:"date",
            valueFormatter: (value) => {
                if(value == null){
                    return null;
                }
                
                const formatObj = new Intl.DateTimeFormat("en-US");
                return (
                    formatObj.format(new Date(value))
                );
            },
        },
        {
            field: 'curReelSerialNumber', 
            headerName: "Reel", 
            description:"Reel Serial Number", 
        },
        {
            field: 'reelTypeName', 
            headerName: "Reel Type", 
            description:"The Class of Reel for the Load", 
        },
        {
            field: 'trackerESN', 
            headerName: "Tracker ESN", 
            description:"The Electronic Serial Number of Reel Tracker", 
        }, 
        {
            field: 'curTrackerLastUpdate', 
            headerName: "Tracker Last Update", 
            description:"The Last Date the Tracker Communicated",
            valueGetter: (value, row) => {
                if(value == null){
                    return null;
                }

                return (
                    new Date(value)
                );
            },
            type:"date",
            valueFormatter: (value) => {
                if(value == null){
                    return null;
                }
                
                const formatObj = new Intl.DateTimeFormat("en-US");
                return (
                    formatObj.format(new Date(value))
                );
            },             
        },                  
        {
            field: 'curTrackerBattery', 
            headerName: "Tracker Battery", 
            description:"Tracker Battery Level", 
            valueGetter: (value, row) => {
                return row.curTrackerBattery==null?0:row.curTrackerBattery.toLocaleString();
            }
        }, 
        {
            field: 'deferralPeriod', 
            headerName: "Deferral Months", 
            description:"The Number of Reel Return Deferral Months", 
        }, 
        {
            field: 'deferralDaysLeft', 
            headerName: "Deferral Days Left", 
            description:"The Number of Days Remaining in the Deferral Perios", 
            valueGetter: (value, row) => {
                return row.deferralDaysLeft==null?null:row.deferralDaysLeft.toLocaleString();
            }
        },         
        {
            field: 'tareWeight', 
            headerName: "Tare Weight", 
            description:"Tare Weight", 
            valueGetter: (value, row) => {
                return row.tareWeight==null?null:row.tareWeight.toLocaleString();
            }
        }, 
        {
            field: 'returnedDate', 
            headerName: "Returned Date", 
            description:"Reel Returned Date", 
        }      
    ];


    function getVisibilityModel(){
        if(smallForm){
            return {}
        }
        else{
            return {}
        }
    };


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    };


    return (
        <Box sx={{width:'100%', height:'100%', minHeight:'400px'}}>
            <DataGridPro
                pagination={true}
                slots={{toolbar: GridToolbar}}
                disableRowSelectionOnClick
                slotProps={{
                    toolbar:{
                        showQuickFilter:true,
                    }
                }}
                rows={props.data} 
                columns={columns} 
                getRowId={row => row.idGuid}
                initialState={{
                    columns:{
                        columnVisibilityModel: getVisibilityModel()
                    },
                    pagination: { paginationModel: { pageSize: 50 } },
                    density: getDensity() 

                }}                
            />
        </Box>
    );
}
